export default {
  props: {
    visible: { type: Boolean, default: false }
  },

  data() {
    return {
      localVisible: this.visible
    }
  },

  watch: {
    visible(val) {
      this.localVisible = val
    }
  },

  methods: {
    open() {
      this.localVisible = true
      this.$emit('open')
    },

    close() {
      this.localVisible = false
      this.$emit('close')
    }
  }
}
